import React from 'react';
import { Nav } from "./items/Nav";

export const News = () => {

const apple_date = '更新至：2026-3-15';
const samsung_date = '更新至：2026-3-15';
const huawei_date = '更新至：2026-3-15';

const Apple_products = [
    { name: 'iPhone 16e 128GB', price: '$2600' },
    { name: 'iPhone 16e 256GB', price: '$3000' },
    { name: 'iPhone 16e 512GB', price: '$3300' },
    { name: 'iPhone 16 128GB', price: '$3400' },
    { name: 'iPhone 16 256GB', price: '$3800' },
    { name: 'iPhone 16 512GB', price: '$4200' },
    { name: 'iPhone 16 Plus 128GB', price: '$4000' },
    { name: 'iPhone 16 Plus 256GB', price: '$4400' },
    { name: 'iPhone 16 Plus 512GB', price: '$4600' },
    { name: 'iPhone 16 Pro 256GB', price: '$5200' },
    { name: 'iPhone 16 Pro 512GB', price: '$5500' },
    { name: 'iPhone 16 Pro 1TB', price: '$6000' },
    { name: 'iPhone 16 Pro Max 256GB', price: '$6000' },
    { name: 'iPhone 16 Pro Max 512GB', price: '$6400' },
    { name: 'iPhone 16 Pro Max 1TB', price: '$7100' },
    { name: 'iPhone 15 128GB', price: '$2600' },
    { name: 'iPhone 15 256GB', price: '$2800' },
    { name: 'iPhone 15 512GB', price: '$3000' },
    { name: 'iPhone 15 PLUS 128GB', price: '$2600' },
    { name: 'iPhone 15 PLUS 256GB', price: '$3000' },
    { name: 'iPhone 15 PLUS 512GB', price: '$3200' },
    { name: 'iPhone 15 Pro 128GB', price: '$3200' },
    { name: 'iPhone 15 Pro 256GB', price: '$3800' },
    { name: 'iPhone 15 Pro 512GB', price: '$4000' },
    { name: 'iPhone 15 Pro 1TB', price: '$4300' },
    { name: 'iPhone 15 Pro Max 256GB', price: '$4600' },
    { name: 'iPhone 15 Pro Max 512GB', price: '$4800' },
    { name: 'iPhone 15 Pro Max 1TB', price: '$5100' },
    { name: 'IPHONE 14 128GB', price: '$1800' },
    { name: 'IPHONE 14 256GB', price: '$2000' },
    { name: 'IPHONE 14 512GB', price: '$2200' },
    { name: 'IPHONE 14 plus 128GB', price: '$2200' },
    { name: 'IPHONE 14 plus 256GB', price: '$2400' },
    { name: 'IPHONE 14 plus 512GB', price: '$2600' },
    { name: 'IPHONE 14 PRO 128GB', price: '$2400' },
    { name: 'IPHONE 14 PRO 256GB', price: '$3000' },
    { name: 'IPHONE 14 PRO 512GB', price: '$3200' },
    { name: 'IPHONE 14 PRO 1TB', price: '$3400' },
    { name: 'IPHONE 14 PRO MAX 128GB', price: '$3000' },
    { name: 'IPHONE 14 PRO MAX 256GB', price: '$3600' },
    { name: 'IPHONE 14 PRO MAX 512GB', price: '$3800' },
    { name: 'IPHONE 14 PRO MAX 1TB', price: '$4000' },
    { name: 'IPHONE 13 MINI 128GB', price: '$1200' },
    { name: 'IPHONE 13 MINI 256GB', price: '$1400' },
    { name: 'IPHONE 13 MINI 512GB', price: '$1600' },
    { name: 'IPHONE 13 128GB', price: '$1400' },
    { name: 'IPHONE 13 256GB', price: '$1600' },
    { name: 'IPHONE 13 512GB', price: '$1800' },
    { name: 'IPHONE 13 PRO 128GB', price: '$1800' },
    { name: 'IPHONE 13 PRO 256GB', price: '$2200' },
    { name: 'IPHONE 13 PRO 512GB', price: '$2400' },
    { name: 'IPHONE 13 PRO 1TB', price: '$2600' },
    { name: 'IPHONE 13 PRO MAX 128GB', price: '$2200' },
    { name: 'IPHONE 13 PRO MAX 256GB', price: '$2800' },
    { name: 'IPHONE 13 PRO MAX 512GB', price: '$3000' },
    { name: 'IPHONE 13 PRO MAX 1TB', price: '$3200' },
    { name: 'IPHONE X 64GB', price: 'HK$500' },
    { name: 'IPHONE X 256GB', price: 'HK$700' },
    { name: 'IPHONE 11 64GB', price: 'HK$800' },
    { name: 'IPHONE 11 128GB', price: 'HK$1000' },
    { name: 'IPHONE 11 256GB', price: 'HK$1100' },
    { name: 'IPHONE 11 PRO 64GB', price: 'HK$900' },
    { name: 'IPHONE 11 PRO 256GB', price: 'HK$1200' },
    { name: 'IPHONE 11 PRO 512GB', price: 'HK$1300' },
    { name: 'IPHONE 11 PRO MAX 64GB', price: 'HK$1000' },
    { name: 'IPHONE 11 PRO MAX 256GB', price: 'HK$1400' },
    { name: 'IPHONE 11 PRO MAX 512GB', price: 'HK$1500' },
    { name: 'IPHONE 12 64GB', price: 'HK$1000' },
    { name: 'IPHONE 12 128GB', price: 'HK$1200' },
    { name: 'IPHONE 12 256GB', price: 'HK$1400' },
    { name: 'IPHONE 12 MINI 64GB', price: 'HK$1000' },
    { name: 'IPHONE 12 MINI 128GB', price: 'HK$1200' },
    { name: 'IPHONE 12 MINI 256GB', price: 'HK$1300' },
    { name: 'IPHONE 12 PRO 128GB', price: 'HK$1300' },
    { name: 'IPHONE 12 PRO 256GB', price: 'HK$1500' },
    { name: 'IPHONE 12 PRO 512GB', price: 'HK$1600' },
    { name: 'IPHONE 12 PRO MAX 128GB', price: 'HK$1800' },
    { name: 'IPHONE 12 PRO MAX 256GB', price: 'HK$2000' },
    { name: 'IPHONE 12 PRO MAX 512GB', price: 'HK$2200' },
    { name: 'IPHONE XR 64GB (A1984)', price: 'HK$500' },
    { name: 'IPHONE XR 128GB (A1984)', price: 'HK$700' },
    { name: 'IPHONE XR 256GB (A1984)', price: 'HK$800' },
    { name: 'IPHONE XS 64GB (A1920)', price: 'HK$600' },
    { name: 'IPHONE XS 256GB (A1920)', price: 'HK$800' },
    { name: 'IPHONE XS 512GB (A1920)', price: 'HK$900' },
    { name: 'IPHONE XS MAX 64GB (A1921)', price: 'HK$500' },
    { name: 'IPHONE XS MAX 256GB (A1921)', price: 'HK$800' },
    { name: 'IPHONE XS MAX 512GB (A1921)', price: 'HK$900' },
    { name: 'IPHONE 7 32GB', price: 'HK$150' },
    { name: 'IPHONE 7 128GB', price: 'HK$200' },
    { name: 'IPHONE 7 256GB', price: 'HK$250' },
    { name: 'IPHONE 7 PLUS 32GB', price: 'HK$200' },
    { name: 'IPHONE 7 PLUS 128GB', price: 'HK$300' },
    { name: 'IPHONE 7 PLUS 256GB', price: 'HK$400' },
    { name: 'IPHONE 8 64GB', price: 'HK$250' },
    { name: 'IPHONE 8 128GB', price: 'HK$300' },
    { name: 'IPHONE 8 256GB', price: 'HK$350' },
    { name: 'IPHONE 8 PLUS 64GB', price: 'HK$300' },
    { name: 'IPHONE 8 PLUS 128GB', price: 'HK$400' },
    { name: 'IPHONE 8 PLUS 256GB', price: 'HK$450' },
    { name: 'IPHONE SE 64GB 2020', price: 'HK$300' },
    { name: 'IPHONE SE 128GB 2020', price: 'HK$400' },
    { name: 'IPHONE SE 256GB 2020', price: 'HK$500' },
  { name: 'iPad 第 6 代（32GB Wifi）', price: ' 請查詢 '},
  { name: 'iPad 第 6 代（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 6 代（32GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 6 代（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2018 款）（64GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2018 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2018 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2018 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2018 款）（64GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2018 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2018 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2018 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 3 代 2018 款）（64GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 3 代 2018 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 3 代 2018 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 3 代 2018 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 3 代 2018 款）（64GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 3 代 2018 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 3 代 2018 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 3 代 2018 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 7 代（32GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 7 代（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 7 代（32GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 7 代（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（2020 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 4 代 2020 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Air 第 4 代（64GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Air 第 4 代（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Air 第 4 代（64GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Air 第 4 代（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 8 代（32GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 8 代（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 8 代（32GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 8 代（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 3 代 2021 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 5 代 2021 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 9 代（64GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 9 代（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 9 代（64GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 9 代（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad mini 第 6 代（64GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad mini 第 6 代（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad mini 第 6 代（64GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad mini 第 6 代（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（第 4 代 2022 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 12.9 英寸（第 6 代 2022 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Air 第 5 代（64GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Air 第 5 代（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Air 第 5 代（64GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Air 第 5 代（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 10 代（64GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 10 代（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad 第 10 代（64GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad 第 10 代（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M4 2024 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M4 2024 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M4 2024 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M4 2024 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M4 2024 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M4 2024 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M4 2024 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M4 2024 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M4 2024 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M4 2024 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M4 2024 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M4 2024 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M4 2024 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M4 2024 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M4 2024 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M4 2024 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M5 2025 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M5 2025 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M5 2025 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M5 2025 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M5 2025 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M5 2025 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M5 2025 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 11 英寸（M5 2025 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M5 2025 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M5 2025 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M5 2025 款）（1TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M5 2025 款）（2TB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M5 2025 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M5 2025 款）（512GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M5 2025 款）（1TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad Pro 13 英寸（M5 2025 款）（2TB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad（A16 2025 款）（128GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad（A16 2025 款）（256GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad（A16 2025 款）（512GB Wifi）', price: ' 請查詢 ' },
  { name: 'iPad（A16 2025 款）（128GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad（A16 2025 款）（256GB Cellular）', price: ' 請查詢 ' },
  { name: 'iPad（A16 2025 款）（512GB Cellular）', price: ' 請查詢 ' },
  {name: 'MacBook Air 13inch（Intel Core i5 8Gb+128GB）', price: ' 請查詢 '},
  { name: 'MacBook Air 13inch（Intel Core i5 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i5 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i5 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i5 16Gb+128GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i5 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i5 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i5 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i7 8Gb+128GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i7 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i7 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i7 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i7 16Gb+128GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i7 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i7 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（Intel Core i7 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i5 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i5 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i5 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i5 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i5 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i5 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i7 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i7 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i7 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i7 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i7 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（Intel Core i7 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i7 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i7 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i7 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i7 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i7 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i7 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i9 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i9 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i9 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i9 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i9 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 15inch（Intel Core i9 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 8Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 16Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 32Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 32Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 64Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 64Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 64Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 64Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i5 64Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 8Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 16Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 32Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 32Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 64Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 64Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 64Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 64Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i7 64Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 8Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 16Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 32Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 32Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 64Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 64Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 64Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 64Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（Intel Core i9 64Gb+4TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M1 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M1 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M1 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M1 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M1 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M1 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M1 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M1 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M1 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M1 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M1 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M1 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M1 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M1 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M1 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M1 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Pro 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Pro 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Pro 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Pro 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Pro 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Pro 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Max 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Max 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Max 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Max 64Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Max 64Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M1 Max 64Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Pro 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Pro 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Pro 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Pro 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Pro 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Pro 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Max 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Max 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Max 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Max 64Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Max 64Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M1 Max 64Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 24Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 24Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 24Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M2 24Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M2 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M2 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M2 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M2 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M2 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M2 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M2 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 13inch（M2 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Pro 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Pro 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Pro 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Pro 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Pro 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Pro 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 64Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 64Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 64Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 96Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 96Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M2 Max 96Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Pro 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Pro 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Pro 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Pro 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Pro 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Pro 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 64Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 64Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 64Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 96Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 96Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M2 Max 96Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 24Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 24Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 24Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M3 24Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 8Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 24Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 24Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 24Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M3 24Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Pro 18Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Pro 18Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Pro 18Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Pro 36Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Pro 36Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Pro 36Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Max 36Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Max 36Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Max 48Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Max 48Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Max 60Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Max 60Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Max 96Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 14inch（M3 Max 96Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 8Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 8Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 8Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Pro 18Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Pro 18Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Pro 18Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Pro 36Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Pro 36Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Pro 36Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Max 36Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Max 36Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Max 48Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Max 48Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Max 60Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Max 60Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Max 96Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M3 Max 96Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 24Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 24Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 24Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 24Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 32Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 13inch（M4 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 16Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 16Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 16Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 16Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 24Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 24Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 24Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 24Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 32Gb+256GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 32Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 32Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Air 15inch（M4 32Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 24Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 24Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 24Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 36Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 36Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 36Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 48Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 48Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Pro 48Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 36Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 36Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 36Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 48Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 48Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 48Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 64Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 64Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 64Gb+2TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 128Gb+512GB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 128Gb+1TB）', price: ' 請查詢 ' },
  { name: 'MacBook Pro 16inch（M4 Max 128Gb+2TB）', price: ' 請查詢 ' }

];

const Samsung_products = [
{ name: 'Samsung 三星 Galaxy S25 5G (12+256GB)', price: '$3000' },
{ name: 'Samsung 三星 Galaxy S25 5G (12+512GB)', price: '$3400' },
{ name: 'Samsung 三星 Galaxy S25 Edge 5G (12+256GB)', price: '$4400' },
{ name: 'Samsung 三星 Galaxy S25 Edge 5G (12+512GB)', price: '$4800' },
{ name: 'Samsung 三星 Galaxy S25+ 5G (12+256GB)', price: '$4200' },
{ name: 'Samsung 三星 Galaxy S25+ 5G (12+512GB)', price: '$4800' },
{ name: 'Samsung 三星 Galaxy S25 Ultra 5G (12+256GB)', price: '$5000' },
{ name: 'Samsung 三星 Galaxy S25 Ultra 5G (12+512GB)', price: '$6000' },
{ name: 'Samsung 三星 Galaxy S25 Ultra 5G (16+1TBGB)', price: '$7000' },
{ name: 'Samsung 三星 Galaxy S24 5G (8+256GB)', price: '$2200' },
{ name: 'Samsung 三星 Galaxy S24 5G (8+512GB)', price: '$2400' },
{ name: 'Samsung 三星 Galaxy S24+ 5G (12+256GB)', price: '$3000' },
{ name: 'Samsung 三星 Galaxy S24+ 5G (12+512GB)', price: '$3200' },
{ name: 'Samsung 三星 Galaxy S24 Ultra 5G (12+256GB)', price: '$3800' },
{ name: 'Samsung 三星 Galaxy S24 Ultra 5G (12+512GB)', price: '$4200' },
{ name: 'Samsung 三星 Galaxy S24 Ultra 5G (12+1TBGB)', price: '$4600' },
{ name: 'Samsung 三星 Galaxy Z Fold6 5G (12+256GB)', price: '$5000' },
{ name: 'Samsung 三星 Galaxy Z Fold6 5G (12+512GB)', price: '$5400' },
{ name: 'Samsung 三星 Galaxy Z Fold6 5G (12+1TB)', price: '$5800' },
{ name: 'Samsung 三星 Galaxy Z Flip6 5G (12+256GB)', price: '$2200' },
{ name: 'Samsung 三星 Galaxy Z Flip6 5G (12+512GB)', price: '$2500' },
{ name: 'Samsung 三星 Galaxy Z Fold5 5G (12+256GB)', price: '$3000' },
{ name: 'Samsung 三星 Galaxy Z Fold5 5G (12+512GB)', price: '$3300' },
{ name: 'Samsung 三星 Galaxy Z Flip5 5G (8+256GB)', price: '$1400' },
{ name: 'Samsung 三星 Galaxy Z Flip5 5G (8+512GB)', price: '$1600' },
{ name: 'Galaxy S23 Ultra 5G 12+256GB', price: '$2800' },
{ name: 'Galaxy S23 Ultra 5G 12+512GB', price: '$3100' },
{ name: 'Galaxy S23 Ultra 5G 12+1TBGB', price: '$3400' },
{ name: 'Galaxy S23+ 5G 12+256GB', price: '$2000' },
{ name: 'Galaxy S23+ 5G 12+512GB', price: '$2200' },
{ name: 'Galaxy S23 5G 8+128GB', price: '$1300' },
{ name: 'Galaxy S23 5G 8+256GB', price: '$1500' },
{ name: 'Samsung Galaxy Z Fold4 5G (12+256GB)', price: '$2000' },
{ name: 'Samsung Galaxy Z Fold4 5G (12+512GB)', price: '$2200' },
{ name: 'Samsung Galaxy Z Flip4 5G (8+256GB)', price: '$1000' },
{ name: 'Samsung Galaxy Z Flip4 5G (8+512GB)', price: '$1200' },
{ name: 'Galaxy S22 5G (8+128GB)', price: '$600' },
{ name: 'Galaxy S22 5G (8+256GB)', price: '$800' },
{ name: 'Galaxy S22+ 5G (8+256GB)', price: '$1000' },
{ name: 'Galaxy S22 Ultra 5G (12+256GB)', price: '$1800' },
{ name: 'Galaxy S22 Ultra 5G (12+512GB)', price: '$2000' },
{ name: 'Galaxy S22 Ultra 5G (12+1TBGB)', price: '$2300' },
{ name: 'Galaxy Z Fold3 5G (12+256GB)', price: '$1200' },
{ name: 'Galaxy Z Fold3 5G (12+512GB)', price: '$1400' },
{ name: 'Galaxy Z Flip3 5G (8+256GB)', price: '$400' },
{ name: 'Galaxy S21 ultra 16+512g', price: '$1400' },
{ name: 'Galaxy S21 ultra 12+256g', price: '$1200' },
{ name: 'Galaxy S21 plus 8+256g', price: '$800' },
{ name: 'Galaxy S21 plus 8+128g', price: '$600' },
{ name: 'Galaxy S21 8+256g', price: '$600' },
{ name: 'Galaxy S21 8+128g', price: '$500' },
{ name: 'Galaxy S20 ultra 16+512g', price: '$1000' },
{ name: 'Galaxy S20 ultra 12+256g', price: '$800' },
{ name: 'Galaxy S20 plus 8+128g', price: '$500' },
{ name: 'Galaxy S20 8+128g', price: '$500' },
{ name: 'Galaxy S20 FE 128g', price: '$400' },
{ name: 'Galaxy S20 FE 256g', price: '$500' },
{ name: 'Galaxy Note 20 ultra 512gb', price: '$1200' },
{ name: 'Galaxy Note 20 ultra 256gb', price: '$1000' },
{ name: 'Galaxy Note 20 5G 256gb', price: '$600' },
{ name: 'Galaxy A53 5G (8+256GB)', price: '$700' },
{ name: 'Samsung 三星 Galaxy A54 5G (8+256GB)', price: '$900' },
{ name: 'Samsung 三星 Galaxy A55 5G (12+256GB)', price: '$1100' },
{ name: 'Samsung 三星 Galaxy A56 5G (12+256GB)', price: '$1800' },
{ name: 'Samsung 三星 Galaxy A36 5G (8+256GB)', price: '$1200' },
{ name: 'Galaxy Note 10 plus 512gb', price: '$600' },
{ name: 'Galaxy Note 10 plus 256gb', price: '$500' },
{ name: 'Galaxy Note 10 256gb', price: '$400' },
{ name: 'Galaxy Note 10 lite 128gb', price: '$400' },
{ name: 'Galaxy Fold2 512g', price: '$900' },
{ name: 'Galaxy Fold 512g', price: '$500' },
{ name: 'Galaxy S10+ 1TB', price: '$600' },
{ name: 'Galaxy S10+ 512g', price: '$500' },
{ name: 'Galaxy S10+ 128g', price: '$400' },
{ name: 'Galaxy S10 512g', price: '$350' },
{ name: 'Galaxy S10 128g', price: '$300' },
{ name: 'Galaxy S10e', price: '$300' },
{ name: 'Galaxy Note 9 512gb', price: '$300' },
{ name: 'Galaxy Note 9 128gb', price: '$300' },
{ name: 'SAMSUNG GALAXY A31', price: '$250' },
{ name: 'SAMSUNG GALAXY A40', price: '$300' },
{ name: 'SAMSUNG GALAXY A40S', price: '$300' },
{ name: 'SAMSUNG GALAXY A50S', price: '$300' },
{ name: 'SAMSUNG GALAXY A60', price: '$200' },
{ name: 'SAMSUNG GALAXY A70 6GB', price: '$250' },
{ name: 'SAMSUNG GALAXY A70 8GB', price: '$300' },
{ name: 'SAMSUNG GALAXY A80', price: '$300' },
{ name: 'SAMSUNG GALAXY A51 (6GB+128GB)', price: '$250' },
{ name: 'SAMSUNG GALAXY A71 (8GB+128GB)', price: '$300' },
{ name: 'SAMSUNG GALAXY A8S', price: '$300' },
{ name: 'SAMSUNG A9 6GB (2018)', price: '$300' },
{ name: 'SAMSUNG A9 8GB (2018)', price: '$300' }
];

const Huawei_products = [
  { name: 'Huawei 華為 Pura X (12+256GB)', price: '$4600' },
  { name: 'Huawei 華為 Pura X (12+512GB)', price: '$5200' },
  { name: 'Huawei 華為 Pura 70 Ultra (16+512GB)', price: '$4000' },
  { name: 'Huawei 華為 Pura 70 Pro+ (16+512GB)', price: '$3500' },
  { name: 'Huawei 華為 Pura 70 Pro (12+512GB)', price: '$3200' },
  { name: 'Huawei 華為 Pura 70 (12+256GB)', price: '$2100' },
  { name: 'Huawei P60 Pro (8+256GB)', price: '$1500' },
  { name: 'Huawei P60 Pro (12+512GB)', price: '$1700' },
  { name: 'HUAWEI P50 PRO 4G 8+256GB', price: '$1000' },
  { name: 'HUAWEI P50 PRO 4G 8+512GB', price: '$1200' },
  { name: 'HUAWEI MATE 40', price: '$1000' },
  { name: 'HUAWEI MATE 40 PRO', price: '$1500' },
  { name: 'HUAWEI MATE 40 PRO PLUS', price: '$1700' },
  { name: 'HUAWEI MATE 40 RS', price: '$3000' },
  { name: 'HUAWEI MATE 20 X (6GB+128GB)', price: '$500' },
  { name: 'HUAWEI MATE 20 X (8GB+256GB)', price: '$600' },
  { name: 'HUAWEI MATE 20', price: '$200' },
  { name: 'HUAWEI MATE 20 PRO', price: '$300' },
  { name: 'P20 128GB', price: '$200' },
  { name: 'P20 PRO 128GB', price: '$400' },
  { name: 'Huawei P30 Pro (8GB+512GB)', price: '$700' },
  { name: 'Huawei P30 Pro (8GB+256GB)', price: '$600' },
  { name: 'Huawei P30 (8GB+128GB)', price: '$400' },
  { name: 'Huawei P30 Lite (6GB+128GB)', price: '$300' },
  { name: 'HUAWEI P40 (8GB+128GB)', price: '$700' },
  { name: 'HUAWEI P40 PRO (8GB+256GB)', price: '$1000' },
  { name: 'Honor 榮耀 Magic V2 5G (16+512GB)', price: '$3000' },
  { name: 'Honor 榮耀 Magic V3 5G (16+512GB)', price: '$5000' },
  { name: 'Honor 榮耀 Magic 7 Pro 5G (16+512GB)', price: '$3800' },
  { name: 'Honor 榮耀 Magic 7 Pro 5G (16GB+1TB)', price: '$4200' },
  { name: 'Honor 榮耀 Magic 6 Pro 5G (12+512GB)', price: '$2600' },
  { name: 'Honor 榮耀 Magic5 Pro 5G (12+512GB)', price: '$1500' },
  { name: 'Honor 榮耀 X9c 5G (12+256GB)', price: '$1100' },
];

   



  return (
    <>
    <title>Comein 二手回收價目表｜ Apple蘋果 Huawei華為 Samsung三星 最新機型回收價格即時查詢</title>
    <meta name="description" content="提供最新Apple蘋果、Huawei華為、Samsung三星全系列二手回收價格參考，涵蓋iPhone 15 Pro、Mate 60、Galaxy S24等熱門機型價格對比，快速估價，安心回收，立即查詢！元朗 天水圍 屯門 元天屯上門回收。" />

    <Nav/>
    <div className="pb-10">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold  text-center pt-10">最新回收報價</h1>
            <div className="min-h-screen bg-white text-black">

                {/* Apple */}
                <div className="container mx-auto px-4 py-8">
                    <h2 className="text-xl  text-yellow-500 font-bold text-center">蘋果Apple 回收價</h2>
                    <p className="text-sm  text-gray-500 text-center mb-8">{apple_date}</p>
                    
                    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                    {Apple_products.map((product, index) => (
                        <div 
                        key={index} 
                        className="bg-white border border-gray-200 rounded-lg p-2 text-center hover:shadow-md transition-shadow"
                        >
                        <div className="text-sm font-medium mb-1">{product.name}</div>
                        <div className="text-md font-bold text-blue-600">{product.price}</div>
                        </div>
                    ))}
                    </div>
                </div>
                </div>

                {/* Samsung */}
                <div className="container mx-auto px-4 py-8">
                    <h2 className="text-xl  text-yellow-500 font-bold text-center">三星Samsung 回收價</h2>
                    <p className="text-sm text-gray-500 text-center mb-8">{samsung_date}</p>
                    
                    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                    {Samsung_products.map((product, index) => (
                        <div 
                        key={index} 
                        className="bg-white border border-gray-200 rounded-lg p-2 text-center hover:shadow-md transition-shadow"
                        >
                        <div className="text-sm font-medium mb-1">{product.name}</div>
                        <div className="text-md font-bold text-blue-600">{product.price}</div>
                        </div>
                    ))}
                    </div>
                </div>

                {/* Huawei */}
                <div className="container mx-auto px-4 py-8">
                    <h2 className="text-xl  text-yellow-500 font-bold text-center">華為Huawei 回收價</h2>
                    <p className="text-sm  text-gray-500 text-center mb-8">{huawei_date}</p>
                    
                    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                    {Huawei_products.map((product, index) => (
                        <div 
                        key={index} 
                        className="bg-white border border-gray-200 rounded-lg p-2 text-center hover:shadow-md transition-shadow"
                        >
                        <div className="text-sm font-medium mb-1">{product.name}</div>
                        <div className="text-md font-bold text-blue-600">{product.price}</div>
                        </div>
                    ))}
                    </div>
                </div>
      
        </div>
    </>
  );
};

export default News;